import React from 'react';
import PropTypes from 'prop-types';
import useModal from '../../hooks/useModal';
import StaffModal from './StaffModal';

const StaffInfoButton = ({
	btnAttrs = { className: '', style: {} },
	iconCls,
	departmentId,
	trackingHandler,
	children
}) => {
	const { show, handleOpen, handleClose } = useModal(trackingHandler);

	return (
		<>
			<button type="button" onClick={handleOpen} {...btnAttrs}>
				<i className={iconCls} aria-hidden="true" />
			</button>

			{show && (
				<StaffModal
					departmentId={departmentId}
					show={show}
					handleClose={handleClose}
				>
					{children}
				</StaffModal>
			)}
		</>
	);
};

StaffInfoButton.propTypes = {
	btnAttrs: PropTypes.shape({
		className: PropTypes.string,
		style: PropTypes.objectOf(PropTypes.string),
		'aria-label': PropTypes.string
	}).isRequired,
	iconCls: PropTypes.string.isRequired,
	departmentId: PropTypes.string.isRequired,
	trackingHandler: PropTypes.func.isRequired,
	children: PropTypes.node.isRequired
};

export default StaffInfoButton;
